/** @jsx jsx */

import type { ReactNode } from 'react';

import { Button, Margin } from '@zapier/design-system';
import { jsx } from '@emotion/core';

type Props = {
  children: ReactNode;
  onClickTestAgain: () => void;
};

const Wrapper = (props: Props) => {
  return (
    <Margin margin="20px">
      <Margin margin="0px 0px 20px 0px">{props.children}</Margin>
      <Button
        aria-label="Test Again"
        color="secondary"
        iconBefore="arrowSmallLeft"
        onClick={props.onClickTestAgain}
        type="button"
      >
        Test Again
      </Button>
    </Margin>
  );
};

Wrapper.defaultProps = {
  children: null,
};

export default Wrapper;
